import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export const constantRoutes = [
    {
        path: '/',
        redirect: '/index',
    },
    {
      path: '/index',
      component: () => import('@/views/index/index')
    },
    {
      path: '/login',
      component: () => import('@/views/login/login')
    },
    {
      path: '/month',
      component: () => import('@/views/month/index')
    },
    {
      path: '/day',
      component: () => import('@/views/day/index')
    },
    {
      path: '/day/add',
      component: () => import('@/views/day/add')
    },
    {
      path: '*',
      component: () => import('@/views/404')
    }
]
const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })
  
const router = createRouter()
export default router